import { render, staticRenderFns } from "./Permits.vue?vue&type=template&id=014bbac9&scoped=true&"
import script from "./Permits.vue?vue&type=script&lang=js&"
export * from "./Permits.vue?vue&type=script&lang=js&"
import style0 from "./Permits.vue?vue&type=style&index=0&id=014bbac9&prod&scoped=true&lang=css&"
import style1 from "./Permits.vue?vue&type=style&index=1&id=014bbac9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014bbac9",
  null
  
)

export default component.exports